import { Link, useParams } from 'react-router-dom';
import NewsCard from '@/components/base/NewsCard';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import { newsList } from '@/mocks/news';

export default function NewsDetailPage() {
  const { id } = useParams();
  const article = newsList.find((item) => item.id === id);

  useDocumentMeta({
    title: article ? `${article.title} - 粉色水蜜桃影视资讯` : '资讯不存在 - 粉色水蜜桃',
    description: article
      ? article.summary
      : '该资讯不存在或已下线，请返回粉色水蜜桃资讯专题浏览最新内容。',
    keywords: article
      ? `${article.title},${article.category},影视资讯,粉色水蜜桃`
      : '粉色水蜜桃,影视资讯',
  });

  if (!article) {
    return (
      <div className="mx-auto flex max-w-[1280px] flex-col items-center justify-center px-4 py-24 text-center md:px-6">
        <i className="ri-file-unknow-line text-5xl text-foreground-400" aria-hidden="true"></i>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
          该资讯不存在或已下线
        </h1>
        <Link
          to="/news"
          className="mt-6 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer dark:text-foreground-950"
        >
          返回资讯专题
        </Link>
      </div>
    );
  }

  const related = newsList.filter((item) => article.relatedIds.includes(item.id)).slice(0, 3);

  return (
    <div className="mx-auto max-w-[1280px] px-4 py-8 md:px-6 md:py-10">
      <nav className="flex flex-wrap items-center gap-2 text-sm text-foreground-500" aria-label="面包屑">
        <Link to="/" className="transition-colors hover:text-primary-600">
          首页
        </Link>
        <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
        <Link to="/news" className="transition-colors hover:text-primary-600">
          资讯专题
        </Link>
        <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
        <span className="line-clamp-1 text-foreground-800">{article.title}</span>
      </nav>

      <div className="mt-6 grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,1fr)_320px]">
        <article className="min-w-0">
          <span className="inline-block rounded-full bg-primary-50 px-3 py-1 text-xs font-medium text-primary-600">
            {article.category}
          </span>
          <h1 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
            {article.title}
          </h1>
          <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 border-b border-background-200 pb-4 text-sm text-foreground-600">
            <span className="flex items-center gap-1">
              <i className="ri-user-3-line text-primary-500" aria-hidden="true"></i>
              {article.author}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line text-primary-500" aria-hidden="true"></i>
              {article.date}
            </span>
          </div>

          <div className="mt-6 aspect-[16/9] w-full overflow-hidden rounded-lg border border-background-200 bg-background-200">
            <img
              src={article.cover}
              alt={`${article.title}配图`}
              title={`${article.title} 粉色水蜜桃资讯`}
              className="h-full w-full object-cover object-top"
            />
          </div>

          <div className="mt-6 space-y-4">
            {article.content.map((paragraph, index) => (
              <p key={index} className="text-sm leading-loose text-foreground-700 md:text-base">
                {paragraph}
              </p>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-background-200 bg-background-50 p-5">
            <p className="text-sm text-foreground-600">
              本文为演示内容，仅供展示网站功能使用。
            </p>
            <Link
              to="/news"
              className="flex items-center gap-1 whitespace-nowrap rounded-full border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-arrow-left-line" aria-hidden="true"></i>
              返回资讯列表
            </Link>
          </div>
        </article>

        <aside>
          <h2 className="font-heading text-lg font-bold text-foreground-950">相关文章推荐</h2>
          <div className="mt-4 space-y-4">
            {related.map((item) => (
              <NewsCard key={item.id} item={item} layout="row" />
            ))}
          </div>
          <div className="mt-6 rounded-lg border border-primary-100 bg-primary-50 p-5">
            <h3 className="text-base font-semibold text-foreground-950">浏览更多影视内容</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              想找一部好看的剧？前往影视分类页，按类型、地区与年份快速筛选。
            </p>
            <Link
              to="/category"
              className="mt-4 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
            >
              进入影视分类
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
        </aside>
      </div>
    </div>
  );
}